// extracted by mini-css-extract-plugin
export default {"link":"XD-z","disabled":"YD-z"};